import type { ApiConfig } from './types';

// Get configuration from URL params or defaults
function getConfig(): ApiConfig {
  const params = new URLSearchParams(window.location.search);

  // Allow overriding via URL params for development
  const apiUrl = params.get('api') || import.meta.env.VITE_API_URL || 'https://goled-production.up.railway.app';
  const wsUrl = params.get('ws') || import.meta.env.VITE_WS_URL || 'wss://goled-ws-production.up.railway.app';

  return {
    baseUrl: apiUrl,
    wsUrl: wsUrl,
  };
}

export const config = getConfig();

// Player settings
export const PLAYER_CONFIG = {
  // Intervals
  HEARTBEAT_INTERVAL_MS: 30000, // 30 seconds
  MANIFEST_REFRESH_INTERVAL_MS: 60000, // 1 minute (safety net for missed WebSocket updates)
  ANALYTICS_FLUSH_INTERVAL_MS: 60000, // 1 minute
  RECONNECT_INTERVAL_MS: 5000, // 5 seconds

  // Timeouts
  API_TIMEOUT_MS: 10000,
  ASSET_LOAD_TIMEOUT_MS: 30000,

  // Cache
  MAX_CACHED_ASSETS: 100,
  CACHE_EXPIRY_DAYS: 7,

  // Transitions
  DEFAULT_TRANSITION_DURATION_MS: 500,

  // Retry
  MAX_RETRY_ATTEMPTS: 3,
  RETRY_BACKOFF_MS: 1000,
} as const;
